import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixedOutcome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentcolor",
		d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 2,
		d: "M7 12c2.5-3.5 4-1.25 5 0s2.5 3.5 5 0"
	})]
});
export default SvgMixedOutcome;
